import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CatDrawer } from "blocks-nextjs/blocks-react/components/Drawer";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import React, { useEffect, useState } from "react";
import ChargingOptionPageDetail from "../OpsPLanner/ChargingOptionPageDetail";
const ChargingOptionDrawer = ({ chargingDrawerActive, onChargingDrawerClose, selectedOptionDetail }) => {
    const [, setIsRefreshComponent] = useState(chargingDrawerActive);
    useEffect(() => {
        setIsRefreshComponent(chargingDrawerActive);
    }, [chargingDrawerActive]);
    return (_jsx(CatDrawer, { "data-test": "charging-option-drawer", disableBackdropClick: false, disableEscClick: true, hasBackdrop: true, isActive: chargingDrawerActive, onBlDrawerClose: () => {
            onChargingDrawerClose();
        }, onBlDrawerOpen: () => {
            setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
            }, 300); // Adjust timeout to match drawer animation
        }, preserveContent: false, width: "50%", children: _jsxs(_Fragment, { children: [_jsx("div", { "data-test": "charging-option-drawer-header", slot: "header", children: _jsx(CatHeading, { "data-test": "charging-option-drawer-title", level: "h1", variant: "title", children: "Charging options details" }) }), chargingDrawerActive && _jsx(ChargingOptionPageDetail, { selectedOptionDetail: selectedOptionDetail })] }) }));
};
export default ChargingOptionDrawer;
